import type { LucideIcon } from 'lucide-react';
import {
    Banknote,
    Bike,
    Boxes,
    Briefcase,
    Building2,
    Calendar,
    Circle,
    ClipboardList,
    Cloud,
    Factory,
    FileSpreadsheet,
    FileText,
    HandCoins,
    Headphones,
    LayoutDashboard,
    LayoutTemplate,
    Package,
    PawPrint,
    Pill,
    Settings,
    ShoppingBag,
    ShoppingCart,
    Store,
    Truck,
    Users,
    Utensils,
    Wallet,
    Wrench,
    Zap,
} from 'lucide-react';

/** Item de menu serializado pelo backend (Menu::preparaMenuNavegacao). */
export type NavChild = {
    id: string;
    label: string;
    href: string;
    target?: string | null;
};

export type NavItem = {
    id: string;
    label: string;
    icon: string;
    href?: string | null;
    target?: string | null;
    children?: NavChild[] | null;
};

const ICON_MAP: Record<string, LucideIcon> = {
    zap: Zap,
    'clipboard-list': ClipboardList,
    'paw-print': PawPrint,
    package: Package,
    users: Users,
    briefcase: Briefcase,
    boxes: Boxes,
    'shopping-cart': ShoppingCart,
    wrench: Wrench,
    wallet: Wallet,
    banknote: Banknote,
    truck: Truck,
    'file-text': FileText,
    'file-spreadsheet': FileSpreadsheet,
    'layout-dashboard': LayoutDashboard,
    'layout-template': LayoutTemplate,
    calendar: Calendar,
    'hand-coins': HandCoins,
    headphones: Headphones,
    bike: Bike,
    'shopping-bag': ShoppingBag,
    store: Store,
    cloud: Cloud,
    factory: Factory,
    utensils: Utensils,
    settings: Settings,
    pill: Pill,
    'building-2': Building2,
    circle: Circle,
};

export function resolveMenuIcon(key: string | undefined | null): LucideIcon {
    if (!key) {
        return Circle;
    }
    return ICON_MAP[key] ?? Circle;
}

/** Compatibilidade tipada com o mock antigo (removido). */
export type MenuChild = NavChild;
export type MenuItem = NavItem;

/** Menu do SNGPC */
export const sngpcMenu: NavItem[] = [
    {
        id: 'dashboard',
        label: 'Dashboard',
        icon: 'layout-dashboard',
        href: '/',
    },
    {
        id: 'cadastros',
        label: 'Cadastros',
        icon: 'clipboard-list',
        children: [
            { id: 'produtos', label: 'Produtos Controlados', href: '/produtos' },
            { id: 'medicos', label: 'Médicos', href: '/medicos' },
            { id: 'pacientes', label: 'Pacientes', href: '/pacientes' },
        ],
    },
    {
        id: 'movimentacoes',
        label: 'Movimentações',
        icon: 'package',
        children: [
            { id: 'entradas', label: 'Entradas', href: '/entradas' },
            { id: 'saidas', label: 'Saídas', href: '/saidas' },
            { id: 'receitas', label: 'Receitas', href: '/receitas' },
        ],
    },
    {
        id: 'estoque',
        label: 'Estoque',
        icon: 'boxes',
        children: [
            { id: 'estoque-controlado', label: 'Estoque Controlado', href: '/estoque' },
            { id: 'saldo', label: 'Saldo por Produto', href: '/saldo' },
            { id: 'inventario', label: 'Inventário', href: '/inventario' },
        ],
    },
    {
        id: 'anvisa',
        label: 'ANVISA',
        icon: 'file-text',
        children: [
            { id: 'exportar-xml', label: 'Exportar XML', href: '/exportar-xml' },
            { id: 'relatorios', label: 'Relatórios Enviados', href: '/relatorios' },
        ],
    },
    {
        id: 'configuracoes',
        label: 'Configurações',
        icon: 'settings',
        children: [
            { id: 'configuracoes-sngpc', label: 'SNGPC e ANVISA', href: '/configuracoes' },
            { id: 'preferencias-layout', label: 'Preferências de layout', href: '/layout' },
        ],
    },
];
